/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Glad_Pure_Buck_MendInputs */

const en_glad_pure_buck_mend = /** @type {(inputs: Glad_Pure_Buck_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferred Channel`)
};

const de_glad_pure_buck_mend = /** @type {(inputs: Glad_Pure_Buck_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevorzugter Kanal`)
};

/**
* | output |
* | --- |
* | "Preferred Channel" |
*
* @param {Glad_Pure_Buck_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const glad_pure_buck_mend = /** @type {((inputs?: Glad_Pure_Buck_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Glad_Pure_Buck_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_glad_pure_buck_mend(inputs)
	return de_glad_pure_buck_mend(inputs)
});